import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Trophy, Award, PlayCircle, Target, Flame } from "lucide-react";
import ImageProfil from "../Profil/ImageProfil";
import { getLeaderboard } from "../../actions/formationLearner.actions";

// Bannière perso (stats) + podium Top 3 (badges) pour gamifier la page Formations.
const FormationsLeaderboard = ({ firstname, mascot }) => {
  const dispatch = useDispatch();
  const [data, setData] = useState(null);

  useEffect(() => {
    let active = true;
    dispatch(getLeaderboard())
      .then((d) => active && setData(d))
      .catch(() => {});
    return () => {
      active = false;
    };
  }, [dispatch]);

  if (!data) return null;

  const { podium = [], me = {} } = data;
  // Ordre d'affichage : 2e à gauche, 1er au centre, 3e à droite
  const slots = [podium[1], podium[0], podium[2]];

  return (
    <div className="lb-wrap">
      {/* Bannière perso */}
      <div className="lb-banner">
        <div className="lb-banner-top">
          {mascot ? (
            <img src={mascot} alt="" aria-hidden="true" className="lb-mascot" />
          ) : (
            <span className="lb-flame">
              <Flame size={16} />
            </span>
          )}
          <div className="lb-banner-headings">
            <span className="lb-greet">
              {me.badges > 0 ? `Continuez, ${firstname} !` : `Lancez-vous, ${firstname} !`}
            </span>
            <p className={`lb-goal ${me.inTop3 ? "is-top" : ""}`}>
              {me.inTop3 ? (
                <>
                  <Trophy size={14} /> Vous êtes sur le podium
                </>
              ) : me.badges > 0 ? (
                <>
                  <Trophy size={14} /> {me.rank}
                  <sup>e</sup> · {me.badgesToTop} badge{me.badgesToTop > 1 ? "s" : ""} pour le podium
                </>
              ) : (
                <>
                  <Trophy size={14} /> Décrochez votre premier badge
                </>
              )}
            </p>
          </div>
        </div>
        <div className="lb-stats">
          <div className="lb-stat">
            <span className="lb-stat-ico badges">
              <Award size={17} />
            </span>
            <span className="lb-stat-text">
              <strong>{me.badges || 0}</strong>
              <span>badge{me.badges > 1 ? "s" : ""}</span>
            </span>
          </div>
          <div className="lb-stat">
            <span className="lb-stat-ico progress">
              <PlayCircle size={17} />
            </span>
            <span className="lb-stat-text">
              <strong>{me.inProgress || 0}</strong>
              <span>en cours</span>
            </span>
          </div>
          <div className="lb-stat">
            <span className="lb-stat-ico score">
              <Target size={17} />
            </span>
            <span className="lb-stat-text">
              <strong>{me.avgScore != null ? `${me.avgScore}%` : "—"}</strong>
              <span>score moyen</span>
            </span>
          </div>
        </div>
      </div>

      {/* Podium Top 3 */}
      <div className="lb-podium">
        <div className="lb-podium-title">
          <Trophy size={16} /> Podium
        </div>
        <div className="lb-podium-row">
          {slots.map((u, i) => {
            const position = i === 0 ? 2 : i === 1 ? 1 : 3;
            if (!u) {
              return (
                <div className={`lb-slot empty rank-${position}`} key={`empty-${position}`}>
                  <div className="lb-slot-avatar placeholder">
                    <span className="lb-slot-rank">{position}</span>
                  </div>
                  <span className="lb-slot-name muted">Libre</span>
                  <span className="lb-slot-badges muted">—</span>
                  <div className="lb-slot-pedestal">{position}</div>
                </div>
              );
            }
            return (
              <div className={`lb-slot rank-${u.position}`} key={u.id}>
                <div className="lb-slot-avatar">
                  <ImageProfil id={u.id} />
                  <span className="lb-slot-rank">{u.position}</span>
                </div>
                <span className="lb-slot-name">{u.firstname}</span>
                <span className="lb-slot-badges">
                  <Award size={12} /> {u.badges}
                </span>
                <div className="lb-slot-pedestal">{u.position}</div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default FormationsLeaderboard;
